import { Button } from "primereact/button";
import { Message } from "primereact/message";
import { Tag } from "primereact/tag";

import { Dialog, DialogHeader, ErrorState, StateMessage } from "@/ds";
import {
  APLICADA_LABEL,
  APLICAR_AVISO,
  APLICAR_CARREGANDO,
  APLICAR_LABEL,
  APLICAR_NOTA_FECHAR,
  APLICAR_SUBTITULO,
  APLICAR_TITULO,
  APLICAR_VAZIO,
} from "./aplicar-referencia-obras-dialog.constants";
import styles from "./aplicar-referencia-obras-dialog.module.scss";
import type { AplicarReferenciaObrasDialogViewModel } from "./types-aplicar-referencia-obras-dialog";

export function AplicarReferenciaObrasDialogView({
  estado,
  erro,
  linhas,
  recarregar,
  fecharLabel,
  fechar,
}: AplicarReferenciaObrasDialogViewModel) {
  return (
    <Dialog
      visible
      size="lg"
      onHide={fechar}
      header={<DialogHeader title={APLICAR_TITULO} subtitle={APLICAR_SUBTITULO} />}
      footer={
        <Button
          type="button"
          label={fecharLabel}
          onClick={fechar}
          data-testid="aplicar-referencia-fechar"
        />
      }
      data-testid="aplicar-referencia-dialog"
    >
      <div className={styles.corpo}>
        <Message
          className="p-message-block"
          severity="info"
          text={APLICAR_AVISO}
          data-testid="aplicar-referencia-aviso"
        />
        {estado === "carregando" ? (
          <StateMessage
            variant="loading"
            title={APLICAR_CARREGANDO}
            inline
            testId="aplicar-referencia-carregando"
          />
        ) : null}
        {estado === "erro" ? (
          <ErrorState
            message={erro ?? undefined}
            onRetry={recarregar}
            inline
            testId="aplicar-referencia-erro"
          />
        ) : null}
        {estado === "vazio" ? (
          <p className={styles.vazio} data-testid="aplicar-referencia-vazio">
            {APLICAR_VAZIO}
          </p>
        ) : null}
        {estado === "lista" ? (
          <ul className={styles.lista}>
            {linhas.map((linha) => (
              <li key={linha.obraId} className={styles.linha} data-testid={linha.testIds.linha}>
                <div className={styles.identificacao}>
                  <span className={styles.rotulo}>{linha.rotulo}</span>
                  <span className={styles.escopos}>{linha.escopos}</span>
                  {linha.erro ? (
                    <p role="alert" className={styles.erro} data-testid={linha.testIds.erro}>
                      {linha.erro}
                    </p>
                  ) : null}
                </div>
                {linha.situacao === "aplicada" ? (
                  <Tag
                    severity="success"
                    value={APLICADA_LABEL}
                    data-testid={linha.testIds.aplicada}
                  />
                ) : (
                  <Button
                    type="button"
                    size="small"
                    label={APLICAR_LABEL}
                    loading={linha.situacao === "aplicando"}
                    onClick={linha.aplicar}
                    data-testid={linha.testIds.aplicar}
                  />
                )}
              </li>
            ))}
          </ul>
        ) : null}
        {estado === "lista" ? (
          <p className={styles.nota} data-testid="aplicar-referencia-nota">
            {APLICAR_NOTA_FECHAR}
          </p>
        ) : null}
      </div>
    </Dialog>
  );
}
